// BYU's undergraduate majors (lane 2, #2745). Read on 2026-10-01 from the official
// 2026-2027 Undergraduate Catalog's Programs list (catalog.byu.edu/programs), through
// the catalog's own program search (the page renders it in the browser). Every BA, BS,
// BFA, BM and BGS program is kept once, under the college the catalog assigns it;
// emphases are folded into their major, and minors and secondary majors are left out.
// The catalog marks some programs with an asterisk; it is not shown here.
const majors = {
    "slug": "brigham-young-university",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree major in BYU's official 2026-2027 Undergraduate Catalog, grouped by the college that offers it, with the degree. Emphases, minors and secondary majors are left out.",
    "groups": [
        {
            "name": "College of Computational, Mathematical, and Physical Sciences",
            "source": {
                "label": "BYU 2026-2027 Undergraduate Catalog, Programs",
                "url": "https://catalog.byu.edu/programs"
            },
            "majors": [
                {
                    "name": "Actuarial Science",
                    "degree": "B.S."
                },
                {
                    "name": "Applied Physics",
                    "degree": "B.S."
                },
                {
                    "name": "Biochemistry",
                    "degree": "B.S."
                },
                {
                    "name": "Chemistry",
                    "degree": "B.A."
                },
                {
                    "name": "Chemistry",
                    "degree": "B.S."
                },
                {
                    "name": "Chemistry Education",
                    "degree": "B.S."
                },
                {
                    "name": "Computer Science",
                    "degree": "B.S."
                },
                {
                    "name": "Data Science",
                    "degree": "B.S."
                },
                {
                    "name": "Earth and Space Science Education",
                    "degree": "B.S."
                },
                {
                    "name": "Environmental Geology",
                    "degree": "B.S."
                },
                {
                    "name": "Geology",
                    "degree": "B.S."
                },
                {
                    "name": "Machine Learning",
                    "degree": "B.S."
                },
                {
                    "name": "Mathematics",
                    "degree": "B.S."
                },
                {
                    "name": "Mathematics Education",
                    "degree": "B.S."
                },
                {
                    "name": "Physical Science Education",
                    "degree": "B.S."
                },
                {
                    "name": "Physics",
                    "degree": "B.S."
                },
                {
                    "name": "Physics Education",
                    "degree": "B.S."
                },
                {
                    "name": "Physics and Astronomy",
                    "degree": "B.S."
                },
                {
                    "name": "Statistics",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "College of Family, Home, and Social Sciences",
            "source": {
                "label": "BYU 2026-2027 Undergraduate Catalog, Programs",
                "url": "https://catalog.byu.edu/programs"
            },
            "majors": [
                {
                    "name": "Anthropology",
                    "degree": "B.A."
                },
                {
                    "name": "Economics",
                    "degree": "B.S."
                },
                {
                    "name": "Family History - Genealogy",
                    "degree": "B.A."
                },
                {
                    "name": "Family Life",
                    "degree": "B.S."
                },
                {
                    "name": "Family and Consumer Sciences Education",
                    "degree": "B.S."
                },
                {
                    "name": "Geography",
                    "degree": "B.S."
                },
                {
                    "name": "History",
                    "degree": "B.A."
                },
                {
                    "name": "History Teaching",
                    "degree": "B.A."
                },
                {
                    "name": "Political Science",
                    "degree": "B.A."
                },
                {
                    "name": "Political Science: Political Strategy",
                    "degree": "B.A."
                },
                {
                    "name": "Psychology",
                    "degree": "B.S."
                },
                {
                    "name": "Social Science Teaching",
                    "degree": "B.S."
                },
                {
                    "name": "Sociology",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "College of Fine Arts and Communications",
            "source": {
                "label": "BYU 2026-2027 Undergraduate Catalog, Programs",
                "url": "https://catalog.byu.edu/programs"
            },
            "majors": [
                {
                    "name": "Acting",
                    "degree": "B.F.A."
                },
                {
                    "name": "Animation",
                    "degree": "B.F.A."
                },
                {
                    "name": "Art",
                    "degree": "B.A."
                },
                {
                    "name": "Art",
                    "degree": "B.F.A."
                },
                {
                    "name": "Art Education K-12",
                    "degree": "B.A."
                },
                {
                    "name": "Commercial Music",
                    "degree": "B.M."
                },
                {
                    "name": "Communications",
                    "degree": "B.A."
                },
                {
                    "name": "Dance",
                    "degree": "B.A."
                },
                {
                    "name": "Dance",
                    "degree": "B.F.A."
                },
                {
                    "name": "Dance Education K-12",
                    "degree": "B.A."
                },
                {
                    "name": "Film",
                    "degree": "B.A."
                },
                {
                    "name": "Graphic Design",
                    "degree": "B.F.A."
                },
                {
                    "name": "Illustration",
                    "degree": "B.F.A."
                },
                {
                    "name": "Interdisciplinary Design",
                    "degree": "B.A."
                },
                {
                    "name": "Music",
                    "degree": "B.A."
                },
                {
                    "name": "Music Composition",
                    "degree": "B.M."
                },
                {
                    "name": "Music Dance Theatre",
                    "degree": "B.F.A."
                },
                {
                    "name": "Music Education",
                    "degree": "B.M."
                },
                {
                    "name": "Music Performance",
                    "degree": "B.M."
                },
                {
                    "name": "Photo- and Lens- Based Design",
                    "degree": "B.F.A."
                },
                {
                    "name": "Product and User Experience Design",
                    "degree": "B.F.A."
                },
                {
                    "name": "Theatre Arts",
                    "degree": "B.A."
                },
                {
                    "name": "Theatre Education K-12",
                    "degree": "B.A."
                }
            ]
        },
        {
            "name": "College of Humanities",
            "source": {
                "label": "BYU 2026-2027 Undergraduate Catalog, Programs",
                "url": "https://catalog.byu.edu/programs"
            },
            "majors": [
                {
                    "name": "Applied English Linguistics",
                    "degree": "B.A."
                },
                {
                    "name": "Arabic Language",
                    "degree": "B.A."
                },
                {
                    "name": "Art History and Curatorial Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Chinese",
                    "degree": "B.A."
                },
                {
                    "name": "Classical Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Comparative Literature",
                    "degree": "B.A."
                },
                {
                    "name": "Editing and Publishing",
                    "degree": "B.A."
                },
                {
                    "name": "English",
                    "degree": "B.A."
                },
                {
                    "name": "English Teaching",
                    "degree": "B.A."
                },
                {
                    "name": "French",
                    "degree": "B.A."
                },
                {
                    "name": "French Studies",
                    "degree": "B.A."
                },
                {
                    "name": "French Teaching",
                    "degree": "B.A."
                },
                {
                    "name": "General Studies",
                    "degree": "B.G.S."
                },
                {
                    "name": "German",
                    "degree": "B.A."
                },
                {
                    "name": "German Teaching",
                    "degree": "B.A."
                },
                {
                    "name": "Interdisciplinary Humanities",
                    "degree": "B.A."
                },
                {
                    "name": "Italian",
                    "degree": "B.A."
                },
                {
                    "name": "Italian Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Japanese",
                    "degree": "B.A."
                },
                {
                    "name": "Korean",
                    "degree": "B.A."
                },
                {
                    "name": "Latin Teaching",
                    "degree": "B.A."
                },
                {
                    "name": "Linguistics",
                    "degree": "B.A."
                },
                {
                    "name": "Philosophy",
                    "degree": "B.A."
                },
                {
                    "name": "Portuguese",
                    "degree": "B.A."
                },
                {
                    "name": "Russian",
                    "degree": "B.A."
                },
                {
                    "name": "Spanish",
                    "degree": "B.A."
                },
                {
                    "name": "Spanish Teaching",
                    "degree": "B.A."
                },
                {
                    "name": "Spanish Translation",
                    "degree": "B.A."
                }
            ]
        },
        {
            "name": "College of Life Sciences",
            "source": {
                "label": "BYU 2026-2027 Undergraduate Catalog, Programs",
                "url": "https://catalog.byu.edu/programs"
            },
            "majors": [
                {
                    "name": "Biodiversity and Conservation",
                    "degree": "B.S."
                },
                {
                    "name": "Bioinformatics",
                    "degree": "B.S."
                },
                {
                    "name": "Biological Science Education",
                    "degree": "B.S."
                },
                {
                    "name": "Biology",
                    "degree": "B.S."
                },
                {
                    "name": "Biophysics",
                    "degree": "B.S."
                },
                {
                    "name": "Cell Biology and Physiology",
                    "degree": "B.S."
                },
                {
                    "name": "Dietetics",
                    "degree": "B.S."
                },
                {
                    "name": "Environmental Science and Sustainability",
                    "degree": "B.S."
                },
                {
                    "name": "Exercise Science",
                    "degree": "B.S."
                },
                {
                    "name": "Exercise and Wellness",
                    "degree": "B.S."
                },
                {
                    "name": "Food Science",
                    "degree": "B.S."
                },
                {
                    "name": "Genetics, Genomics, and Biotechnology",
                    "degree": "B.S."
                },
                {
                    "name": "Medical Laboratory Science",
                    "degree": "B.S."
                },
                {
                    "name": "Microbiology",
                    "degree": "B.S."
                },
                {
                    "name": "Molecular Biology",
                    "degree": "B.S."
                },
                {
                    "name": "Neuroscience",
                    "degree": "B.S."
                },
                {
                    "name": "Nutritional Science",
                    "degree": "B.S."
                },
                {
                    "name": "Plant and Landscape Systems",
                    "degree": "B.S."
                },
                {
                    "name": "Public Health",
                    "degree": "B.S."
                },
                {
                    "name": "Wildlife and Wildlands Conservation",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "College of Nursing",
            "source": {
                "label": "BYU 2026-2027 Undergraduate Catalog, Programs",
                "url": "https://catalog.byu.edu/programs"
            },
            "majors": [
                {
                    "name": "Nursing",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "Ira A. Fulton College of Engineering",
            "source": {
                "label": "BYU 2026-2027 Undergraduate Catalog, Programs",
                "url": "https://catalog.byu.edu/programs"
            },
            "majors": [
                {
                    "name": "Chemical Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Civil Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Computer Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Construction and Facilities Management",
                    "degree": "B.S."
                },
                {
                    "name": "Cybersecurity",
                    "degree": "B.S."
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Manufacturing Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Technology and Engineering Education",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "Kennedy Center for International Studies",
            "source": {
                "label": "BYU 2026-2027 Undergraduate Catalog, Programs",
                "url": "https://catalog.byu.edu/programs"
            },
            "majors": [
                {
                    "name": "American Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Ancient Near Eastern Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Asian Studies",
                    "degree": "B.A."
                },
                {
                    "name": "European Studies",
                    "degree": "B.A."
                },
                {
                    "name": "International Relations",
                    "degree": "B.A."
                },
                {
                    "name": "Latin American Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Middle East Studies / Arabic",
                    "degree": "B.A."
                }
            ]
        },
        {
            "name": "Marriott School of Business",
            "source": {
                "label": "BYU 2026-2027 Undergraduate Catalog, Programs",
                "url": "https://catalog.byu.edu/programs"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "B.S."
                },
                {
                    "name": "Business Management",
                    "degree": "B.S."
                },
                {
                    "name": "Entrepreneurial Management",
                    "degree": "B.S."
                },
                {
                    "name": "Experience Design and Management",
                    "degree": "B.S."
                },
                {
                    "name": "Finance",
                    "degree": "B.S."
                },
                {
                    "name": "Global Supply Chain Management",
                    "degree": "B.S."
                },
                {
                    "name": "Human Resource Management",
                    "degree": "B.S."
                },
                {
                    "name": "Information Systems",
                    "degree": "B.S."
                },
                {
                    "name": "Marketing",
                    "degree": "B.S."
                },
                {
                    "name": "Strategic Management",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "McKay School of Education",
            "source": {
                "label": "BYU 2026-2027 Undergraduate Catalog, Programs",
                "url": "https://catalog.byu.edu/programs"
            },
            "majors": [
                {
                    "name": "Communication Disorders",
                    "degree": "B.S."
                },
                {
                    "name": "Early Childhood Education",
                    "degree": "B.S."
                },
                {
                    "name": "Elementary Education",
                    "degree": "B.S."
                },
                {
                    "name": "Physical Education Tchg/Coaching (K-12)",
                    "degree": "B.S."
                },
                {
                    "name": "Special Education",
                    "degree": "B.S."
                }
            ]
        }
    ]
};

export default majors;
